import { CONVERSATION_CONSTANTS } from "../helpers/constants";
import { MdMoreHoriz } from "react-icons/md";

import "./typing-indicator.css";

export default function TypingIndicator(props) {
    /**
     * Generates a classname for Typing Indicator metadata using list of active participants.
     * @returns {string}
     */
    function getTypingIndicatorText() {
        const names = Object.keys(props.typingParticipants || {});
        const first = names[0];
        const firstRole = props.typingParticipants?.[first]?.role;

        if (names.length > 1) return "Multiple people are typing";
        if ([CONVERSATION_CONSTANTS.ParticipantRoles.AGENT, CONVERSATION_CONSTANTS.ParticipantRoles.CHATBOT].includes(firstRole)) {
            return `${first} is typing`;
        }
        return '';
    }

    return (
        <div className="typingIndicatorContainer">
            <div className="typingIndicatorBubbleWrapper">
                <div className="typingIndicatorBubble">
                    <MdMoreHoriz className="typingIcon" />
                </div>
                <p className="typingIndicatorSenderContent">{getTypingIndicatorText()}</p>
            </div>
        </div>
    );
}